import React from "react";
import spinner from "./img/spinner-white.gif";
import {
  LoadingWrapper,
  LoadingSpinner,
  LoadingText,
} from "./styles/applicant-review-form-styles";

const Loading = () => (
  <LoadingWrapper data-test-id="applicant-review-page-loading">
    <LoadingSpinner
      src={spinner}
      alt="Loading Spinner"
      data-test-id="loading-spinner"
    />
    <LoadingText data-test-id="loading-text">Loading...</LoadingText>
  </LoadingWrapper>
);

export default Loading;
